import { useState, useCallback } from 'react'
import { connect } from 'react-redux'
import { reduxForm, submit } from 'redux-form'
import { Modal } from '../../components/common'
import { AP_AGREEMENT_MODAL, AP_AGREEMENT_FIELDS as FIELDS } from '../../constants/SetupConstants'
import { updateOrgSettings } from '../../actions/settingsOrg'
import ApAgreementForm from '../../components/setup/apagreement/ApAgreement'

const mapStateToProps = state => {
  const {
    user: {
      data: { selectedOrgId },
    },
    settingsOrg,
  } = state
  const orgSettings = settingsOrg[selectedOrgId]?.data

  return {
    selectedOrgId,
    orgSettings,
  }
}

const ApAgreementModal = ({
  error,
  handleSubmit,
  invalid,
  submitting,
  submitSucceeded,
  submit,
}) => {
  const [hasViewedAgreement, setHasViewedAgreement] = useState(false)

  const handleViewedChange = useCallback(viewed => {
    setHasViewedAgreement(viewed)
  }, [])

  const footerActions = [
    {
      buttonLabel: 'Submit',
      isPrimary: true,
      isDisabled: submitting || invalid || !hasViewedAgreement,
      onClick: () => {
        submit(AP_AGREEMENT_MODAL)
      },
      busy: submitting,
    },
  ]

  return (
    <Modal
      headerTitle="AP Agreement"
      isDismissable={false}
      hideCloseButton
      modalClass="modal-lg"
      shouldCloseModal={submitSucceeded}
      footerActions={footerActions}
    >
      <form onSubmit={handleSubmit}>
        <ApAgreementForm
          error={error}
          initialValues={{ [FIELDS.AP_AGREEMENT_IND.name]: false }}
          currentValues={{ [FIELDS.AP_AGREEMENT_IND.name]: false }}
          onViewedChange={handleViewedChange}
        />
      </form>
    </Modal>
  )
}

export default connect(mapStateToProps, { submit, updateOrgSettings })(
  reduxForm({
    form: AP_AGREEMENT_MODAL,
    onSubmit: (data, dispatch, { updateOrgSettings, orgSettings }) => {
      return updateOrgSettings({
        ...orgSettings,
        participationForm: {
          ...orgSettings.participationForm,
          dpaAgreement: {},
        },
      })
    },
  })(ApAgreementModal)
)
